import React, { Component } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import './lastevent.css'
import events from '../events.json'
import Slider from './Slider'




export default class EventsGrid extends Component {
    constructor(props) {
        super(props);
        this.state = { latestEvent: {}, events: events };
    }

    componentDidMount() {
        console.log("events", events);
        console.log("from did");
        let sortedArray = events.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
        });

        console.log("a", sortedArray);

        let latestEvent = sortedArray.shift();
        console.log("d", latestEvent);
        this.setState({ latestEvent: latestEvent, events: sortedArray })
    }

    render() {
        return (
            <div id="events">
                <Row className='hero-row' >
                    <Col md={10} sm={11}>
                        <img src={this.state.latestEvent.imgUrl} className='hero-img' />
                        <div className='latest'>
                            <h4>Our Latest Show </h4>
                            <h5><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16" style={{ color: '#ffc200', marginBottom: "1px" }} >
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                            </svg>{this.state.latestEvent.location}</h5>
                            <h6>{this.state.latestEvent.date}</h6>
                        </div>

                    </Col>

                </Row>
                <Row className='events-row'>
                    {this.state.events.map(el => {
                        return <Col className='event-col' md={5} sm={12} >
                            <Card className='event-card'>
                                {/* <Card.Img variant="top" src={el.imgUrl} /> */}
                                <Slider/>
                                <Card.Body>
                                    <Card.Title style={{ color: '#e0e0e0', fontWeight: 800, fontSize: 'large' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16" style={{ color: '#ffc200', marginBottom: '3px' }} >
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                        </svg>  {el.location}
                                    </Card.Title>
                                    <h6 style={{ color: '#e0e0e0' }}>{el.date}</h6>
                                </Card.Body>
                            </Card>
                        </Col>
                    })}
                </Row>
            </div>
        )
    }
}
